import styled from 'styled-components/macro'
import { respondAbove } from 'styles/mediaQueries'
import { scrollbar } from 'styles/mixins'
import { Field } from 'components/shared/Input/styles'

interface OptionsProps {
    parentWidth?: number
}

export const Options = styled.span<OptionsProps>`
    ${scrollbar}

    width: ${({ parentWidth }) => (parentWidth ? `${parentWidth}px` : '100%')};
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    max-height: 200px;
    overflow: auto;
    padding: 10px 0;
    border: 2px solid ${({ theme }) => theme.colors.grayscale_400};
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    margin-left: ${({ parentWidth }) => (parentWidth ? '0' : '4px')};

    @media ${respondAbove.xl} {
        border-radius: 8px;
    }
`

interface OptionProps {
    isDisabled?: boolean
}

export const Option = styled.span<OptionProps>`
    width: 100%;
    padding: 10px 20px;
    cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'pointer')};

    &:focus-visible * {
        color: ${({ theme }) => theme.colors.secondary_500};
    }
`

export const TippyWrapper = styled.div`
    width: 100%;
    position: relative;

    @media ${respondAbove.xl} {
        max-width: 370px;
    }

    > div:first-child {
        &[aria-expanded='true'] {
            > input {
                border: 2px solid ${({ theme }) => theme.colors.secondary_500};
                border-radius: 8px;
            }
        }
    }

    [data-tippy-root],
    .tippy-box,
    .tippy-content {
        width: 100%;
    }

    [data-tippy-root] {
        margin-left: -4px !important;
    }
    .tippy-box {
        max-width: 100% !important;
        @media ${respondAbove.xl} {
            max-width: 370px !important;
        }
    }

    ${Field} {
        padding-right: 54px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        opacity: 1;
    }

    &:focus-visible {
        ${Field} {
            border-color: ${({ theme }) => theme.colors.secondary_500};
        }
    }
`
